<template>
  <div>
    <v-card>
      <v-card-title>
        Collection
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click.prevent="updateCollection()"
            >Save</v-btn
          >
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click.prevent="cancel()"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card-title>
    </v-card>
    <v-row>
      <!-- 기본정보 카드영역 -->
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card>
          <v-card-text class="mt-4">
            <v-form ref="modeForm">
              <v-row>
                <v-col cols="12" sm="12" lg="12">
                  <h6
                    class="subtitle-1 blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Mode
                  </h6>
                  <div class="d-flex align-center mt-3">
                    <div
                      class="caption blue-grey--text text--darken-2 font-weight-regular"
                    >
                      Collection
                    </div>
                    <v-switch
                      class="ml-auto ma-0"
                      v-model="mode_collection"
                      inset
                      hide-details
                      dense
                    ></v-switch>
                  </div>
                  <div class="d-flex align-center mt-3">
                    <div
                      class="caption blue-grey--text text--darken-2 font-weight-regular"
                    >
                      Api
                    </div>
                    <v-switch
                      class="ml-auto ma-0"
                      v-model="mode_api"
                      inset
                      hide-details
                      dense
                    ></v-switch>
                  </div>
                  <div class="mt-2" v-if="mode_api">
                    <div class="ma-0 caption">Allowed hosts</div>
                    <div class="domain-wrap">
                      <div class="caption" v-if="api_domains.length > 0">
                        {{ api_domains.toString() }}
                      </div>
                      <div class="caption" v-if="api_domains.length == 0">
                        No hosts are allowed. Contact service manager
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text class="mt-4">
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="12" lg="12">
                  <h6
                    class="subtitle-1 blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Header
                  </h6>
                  <div class="d-flex align-center mt-3">
                    <div
                      class="caption blue-grey--text text--darken-2 font-weight-regular"
                    >
                      Show Header
                    </div>
                    <v-switch
                      class="ml-auto ma-0"
                      v-model="header"
                      inset
                      hide-details
                      dense
                    ></v-switch>
                  </div>
                  <div class="d-flex align-center mt-3">
                    <div
                      class="caption blue-grey--text text--darken-2 font-weight-regular"
                    >
                      Show Category
                    </div>
                    <v-switch
                      class="ml-auto ma-0"
                      v-model="show_category"
                      inset
                      dense
                      hide-details
                    ></v-switch>
                  </div>
                  <v-row class="mt-2">
                    <v-col cols="12">
                      <v-text-field
                        label="Title"
                        color="channel"
                        required
                        v-model="title"
                        :rules="[ruleTitle]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-textarea
                        label="Body"
                        v-model="info"
                        filled
                        class="caption"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <!--Background-->
        <v-card>
          <v-card-text class="mt-4">
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="12" lg="12">
                  <h6
                    class="subtitle-1 blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Background
                  </h6>
                  <v-row class="mt-2">
                    <!-- background of header -->
                    <v-col cols="12" class="pb-0">
                      <v-file-input
                        v-if="!back_img"
                        v-model="back_img"
                        :rules="backgroundRules"
                        label="Background"
                        color="live"
                        prepend-icon=""
                        accept="image/png, image/jpeg"
                        @change="backgroundImageSave('back_img')"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-4" v-if="back_img">
                      <div class="d-flex">
                        <div class="subheading">Background of header</div>
                        <div class="pt-0 ml-auto">
                          <v-btn
                            icon
                            @click="backgroundImageDelete('back_img')"
                          >
                            <v-icon small>mdi-delete-forever</v-icon></v-btn
                          >
                        </div>
                      </div>
                      <v-img
                        height="60"
                        aspect-ratio="3"
                        :src="backgroundImageHeaderUrl"
                      ></v-img>
                    </v-col>
                    <!-- background of login -->
                    <v-col cols="12" class="pb-0">
                      <v-file-input
                        v-if="!back_img_login"
                        v-model="back_img_login"
                        :rules="backgroundRules"
                        label="BackgroundLogin"
                        color="live"
                        prepend-icon=""
                        accept="image/png, image/jpeg"
                        @change="backgroundImageSave('back_img_login')"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" class="pt-0 pb-4" v-if="back_img_login">
                      <div class="d-flex">
                        <div class="subheading">Background of login</div>
                        <div class="pt-0 ml-auto">
                          <v-btn
                            icon
                            @click="backgroundImageDelete('back_img_login')"
                          >
                            <v-icon small>mdi-delete-forever</v-icon></v-btn
                          >
                        </div>
                      </div>
                      <v-img
                        height="60"
                        aspect-ratio="3"
                        :src="backgroundImageLoginUrl"
                      ></v-img>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <!-- items 영역 -->
        <v-card>
          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h6
                  class="subtitle-1 blue-grey--text text--darken-2 font-weight-regular"
                >
                  Items
                </h6>

                <v-row class="mt-0">
                  <v-col cols="12" md="4">
                    <v-btn
                      small
                      block
                      dark
                      depressed
                      color="teal"
                      height="50"
                      @click="collectionCategoryDialog = true"
                      >add<br />Category</v-btn
                    >
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-btn
                      small
                      block
                      dark
                      depressed
                      color="channelbtn"
                      height="50"
                      @click="collectionContentDialog = true"
                      >add<br />Contents</v-btn
                    >
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-btn
                      small
                      block
                      dark
                      depressed
                      color="error lighten-1"
                      height="50"
                      @click="collectionLiveDialog = true"
                      >add<br />Live</v-btn
                    ></v-col
                  >
                </v-row>
                <div class="d-flex align-center mt-3">
                  <div
                    class="caption blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Show Author
                  </div>
                  <v-switch
                    class="ml-auto ma-0"
                    v-model="show_item_author"
                    inset
                    hide-details
                    dense
                  ></v-switch>
                </div>
                <div class="d-flex align-center mt-3">
                  <div
                    class="caption blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Show View
                  </div>
                  <v-switch
                    class="ml-auto ma-0"
                    v-model="show_item_view"
                    inset
                    hide-details
                    dense
                  ></v-switch>
                </div>
                <div class="d-flex align-center mt-3">
                  <div
                    class="caption blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Show Date
                  </div>
                  <v-switch
                    class="ml-auto ma-0"
                    v-model="show_item_date"
                    inset
                    hide-details
                    dense
                  ></v-switch>
                </div>
                <div class="mt-6" v-if="show_item_date == true">
                  <v-text-field
                    v-model="show_item_date_format"
                    dense
                    label="Date Format"
                    value="%YYYY%-%MM%-%DD%"
                    hint="%YYYY%-%MM%-%DD% => 2022-12-17, %MM%/%YYYY% => 12/2022"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 프라이버시 영역 -->
        <v-card>
          <v-card-text class="mt-4">
            <v-form ref="form1">
              <v-row>
                <v-col cols="12" sm="12" md="12" class="pb-6">
                  <h6
                    class="subtitle-1 blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Privacy
                  </h6>
                  <h6 class="caption font-weight-light">
                    Choose who can (or can’t) see your collection.
                  </h6>
                  <v-row>
                    <v-col cols="12" class="mt-3">
                      <v-select
                        v-model="who"
                        :items="whoOptions"
                        label="Who"
                        color="channel"
                        item-text="label"
                        prepend-icon="mdi-security"
                        hide-details
                      ></v-select>
                    </v-col>
                    <!-- KEY 방식 -->
                    <v-col cols="12" v-show="who == 'key'">
                      <v-text-field
                        v-model="key"
                        label="KEY"
                        color="channel"
                        :rules="[ruleKey]"
                        counter="10"
                        class="pa-0 ma-0 ml-10"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <!-- Allowd User 방식 -->
                    <v-col cols="12" v-if="who == 'allowed'" class="d-flex">
                      <v-btn
                        class="ml-auto"
                        depressed
                        color="teal"
                        small
                        dark
                        @click="editUsers"
                        >Edit Allowed Users</v-btn
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="when"
                        :items="whenOptions"
                        color="channel"
                        label="When"
                        item-text="label"
                        prepend-icon="mdi-timer"
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="when == 'schedule'">
                      <div class="d-flex ml-9">
                        <v-icon class="text-center pr-2"
                          >mdi-calendar-clock</v-icon
                        >
                        <VueCtkDateTimePicker
                          id="WhenStartTimePicker"
                          label="Start"
                          v-model="when_start"
                          format="YYYY-MM-DD HH:mm"
                          formatted="YYYY-MM-DD HH:mm"
                          minuteInterval="5"
                          class="pr-2"
                          right
                          color="purple"
                        />
                        <VueCtkDateTimePicker
                          id="WhenEndTimePicker"
                          label="End"
                          v-model="when_end"
                          format="YYYY-MM-DD HH:mm"
                          formatted="YYYY-MM-DD HH:mm"
                          right
                          minuteInterval="5"
                          color="purple"
                        />
                      </div>
                      <div class="d-flex ml-9">
                        <h6 class="ml-auto caption font-weight-light pa-1">
                          timezone: {{ timezone }}
                        </h6>
                      </div>
                      <div class="d-flex ml-9">
                        <h6
                          class="ml-auto caption font-weight-light pa-1 red--text"
                        >
                          {{ this.ruleTextSchedule }}
                        </h6>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="where"
                        :items="whereOptions"
                        label="Where"
                        color="channel"
                        item-text="label"
                        prepend-icon="mdi-server-network"
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="where == 'domain'" class="pt-0 mt-0">
                      <v-text-field
                        v-model="domain"
                        placeholder="ex) www.naver.com"
                        color="channel"
                        clearable
                        append-icon="mdi-plus"
                        @click:append="addDomain"
                        class="ml-9"
                      ></v-text-field>
                      <div
                        class="d-flex justify-end pa-0"
                        v-for="(where_domain, i) in where_domains"
                        :key="i"
                      >
                        <v-btn text small class="domain"
                          >{{ where_domain
                          }}<v-icon small @click="removeDomain(where_domain)"
                            >mdi-delete-forever</v-icon
                          ></v-btn
                        >
                      </div>
                    </v-col>
                    <!-- 컨텐츠 허용유저 -->
                    <v-dialog
                      v-model="contentUsersDialog"
                      style="z-index: 10000"
                      max-width="600px"
                    >
                      <contentAllowedUser
                        :content_id="id"
                        :who_groups="who_groups"
                        v-on:onCloseContentUsersDialog="closeContentUsersDialog"
                        v-on:onUpdateGroups="updateWhoGroups"
                      ></contentAllowedUser>
                    </v-dialog>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- 프리뷰 영역 -->
      <v-col cols="12" sm="8" md="8" lg="8">
        <v-card>
          <v-card-text class="mt-4">
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h6
                    class="subtitle-1 blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Preview
                  </h6>
                  <h6 class="caption font-weight-light">
                    This is the collection preview screen.
                  </h6>
                  <iframe
                    :src="previewUrl"
                    scrolling="auto"
                    style="width: 100%; min-height: 600px"
                    id="previewIfm"
                  ></iframe>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- 컨텐츠 리스트 모달 창 -->
    <v-dialog v-model="collectionContentDialog" max-width="800px">
      <collectionContent
        :selected_contents="selected_contents"
        v-on:onCloseCollectionContentDialog="closeCollectionContentDialog"
      ></collectionContent>
    </v-dialog>
    <!-- 카테고리 리스트 모달 창 -->
    <v-dialog v-model="collectionCategoryDialog" max-width="800px">
      <collectionCategory
        :selected_categories="selected_categories"
        v-on:onCloseCollectionCategoryDialog="closeCollectionCategoryDialog"
      ></collectionCategory>
    </v-dialog>
    <!-- 라이브 리스트 모달 창 -->
    <v-dialog v-model="collectionLiveDialog" max-width="800px">
      <collectionLive
        :selected_lives="selected_lives"
        v-on:onCloseCollectionLiveDialog="closeCollectionLiveDialog"
      ></collectionLive>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { updateCollection, createFile, deleteFile } from "../graphql/Mutation";
import { getCollection } from "../graphql/Query";
import { Base64 } from "js-base64";
const _up = process.env.VUE_APP_KEY_MASS_UP;
const _down = process.env.VUE_APP_KEY_MASS_DOWN;

const contentAllowedUser = () => import("@/components/ContentAllowedUser");
const collectionContent = () => import("@/components/CollectionContents");
const collectionCategory = () => import("@/components/CollectionCategory");
const collectionLive = () => import("@/components/CollectionLive");

export default {
  name: "CollectionEdit",
  components: {
    contentAllowedUser,
    collectionContent,
    collectionCategory,
    collectionLive,
  },
  data: () => ({
    content: null,
    contentUsersDialog: false,
    collectionContentDialog: false,
    collectionCategoryDialog: false,
    collectionLiveDialog: false,
    editInfo: "",
    // content
    id: "",
    title: "",
    info: "",
    back_img: null,
    back_img_login: null,
    mode_collection: true,
    mode_api: true,
    api_domains: [],
    header: true,
    show_category: true,
    show_item_author: true,
    show_item_view: true,
    show_item_date: true,
    show_item_date_format: "%YYYY%-%MM%-%DD",
    selected_contents: [],
    selected_categories: [],
    selected_lives: [],
    who: "me",
    who_groups: [],
    key: "",
    groups: "",
    when: "permanent",
    when_start: "",
    when_end: "",
    where: "anywhere",
    domain: "",
    where_domains: [],
    whoOptions: [
      /** me, anyone, key, allowd */
      { label: "Only me", value: "me" },
      { label: "Anyone", value: "anyone" },
      { label: "Users with key", value: "key" },
      { label: "Allowed users", value: "allowed" },
    ],
    whereOptions: [
      { label: "Anywhere", value: "anywhere" },
      { label: "Specific domains", value: "domain" },
    ],
    whenOptions: [
      { label: "Permanent", value: "permanent" },
      { label: "Schedule", value: "schedule" },
    ],
    addItems: [
      { title: "Upload Videos", action: "upload" },
      { title: "Embed Video", action: "embed" },
    ],
    showOptional: false,
    switch1: true,
    width: "",
    ruleTextSchedule: "",
    backgroundRules: [
      (file) =>
        !file ||
        file.size < 2097152 ||
        "Background size should be less than 2 MB!",
    ],
    previewUrl: "",
  }),
  computed: {
    timezone: function () {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    minDate: function () {
      const currentTime = moment().tz(this.timezone).format();
      return currentTime;
    },
    date_local: function () {
      return this.date ? moment(this.date).tz(this.timezone).format() : null;
    },
    when_start_local: function () {
      return this.when_start
        ? moment(this.when_start).tz(this.timezone).format()
        : null;
    },
    when_end_local: function () {
      return this.when_end
        ? moment(this.when_end).tz(this.timezone).format()
        : null;
    },
    backgroundImageHeaderUrl: function () {
      let url = null;
      if (typeof this.back_img == "string") {
        url =
          process.env.VUE_APP_BASE_URL +
          `/pub/channel/${this.$store.state.channelId}/collection/${this.id}/background/` +
          this.back_img;
      }
      return url;
    },
    backgroundImageLoginUrl: function () {
      let url = null;
      if (typeof this.back_img_login == "string") {
        url =
          process.env.VUE_APP_BASE_URL +
          `/pub/channel/${this.$store.state.channelId}/collection/${this.id}/background/` +
          this.back_img_login;
      }
      return url;
    },
    // previewUrl: function() {
    //   return process.env.VUE_APP_BASE_URL + `/collection/${this.id}`;
    // }
  },
  async mounted() {
    await this.init();
  },
  methods: {
    addDomain() {
      if (this.domain) {
        this.where_domains.push(this.domain);
      }
      this.domain = "";
    },
    async backgroundImageSave(field_name) {
      let returnedFileName;

      const file = this[field_name];
      if (!file) return;

      if (file.size > 3200000) {
        this[field_name] = null;
        return;
      }
      this.uploading = true;

      try {
        const { data } = await this.$apollo.mutate({
          mutation: createFile,
          variables: {
            name: file.name,
            fileType: file.type,
            channel_id: this.$store.state.channelId,
            collection_id: this.id,
            mode: "backgroundCollection",
          },
          fetchPolicy: "no-cache",
        });

        if (data) {
          returnedFileName = data.createFile.name;
          const returnedUrl = data.createFile.url;
          try {
            await this.$axiosS3Public.put(returnedUrl, file, {
              headers: { "Content-Type": file.type },
            });
            this.uploading = false;
            this.uploadSuccess = true;
          } catch (e) {
            this.uploadSuccess = false;
          }
        }
      } catch (e) {
        console.log("Upload Eror", e);
      }

      if (this.uploadSuccess) {
        this[field_name] = returnedFileName;
      }
    },

    async backgroundImageDelete(img_field) {
      try {
        await this.$apollo.mutate({
          mutation: deleteFile,
          variables: {
            name: this[img_field],
            channel_id: this.$store.state.channelId,
            collection_id: this.id,
            mode: "backgroundCollection",
          },
          fetchPolicy: "no-cache",
        });
        this[img_field] = null;
      } catch (e) {
        console.log(" delete error", e);
      }
    },

    async cancel() {
      // 목록페이지로 이동
      this.$router.push({
        name: "Collections",
        query: { from: "edit" },
      });
    },

    closeContentUsersDialog() {
      this.contentUsersDialog = false;
    },
    closeCollectionContentDialog(selected) {
      this.selected_contents = selected;
      console.log(this.selected_contents);
      this.collectionContentDialog = false;
    },
    closeCollectionCategoryDialog(selected) {
      this.selected_categories = selected;
      console.log(this.selected_categories);
      this.collectionCategoryDialog = false;
    },
    closeCollectionLiveDialog(selected) {
      this.selected_lives = selected;
      console.log(this.selected_lives);
      this.collectionLiveDialog = false;
    },

    editUsers() {
      this.contentUsersDialog = true;
    },

    async getCollection(id) {
      /**
       * 컨텐츠 정보 가져오기
       */
      try {
        const { data } = await this.$apollo.query({
          query: getCollection,
          variables: {
            id: id,
          },
          fetchPolicy: "no-cache",
        });
        console.log("[Collection Edit]", data);
        const collection = data.getCollection;
        this.collection = collection;
        this.id = collection.id;
        this.title = collection.title;
        this.info = collection.info;
        this.mode_collection = collection.mode_collection
          ? collection.mode_collection
          : false;
        this.mode_api = collection.mode_api ? collection.mode_api : false;
        this.info = collection.info;
        this.header = collection.header;
        this.back_img = collection.back_img;
        this.back_img_login = collection.back_img_login;
        this.selected_contents = collection.selected_contents;
        this.selected_categories = collection.selected_categories;
        this.selected_lives = collection.selected_lives;
        this.who = collection.who;
        this.who_groups = collection.who_groups ? collection.who_groups : [];
        this.key = collection.key
          ? Base64.decode(collection.key).replace(_up, "").replace(_down, "")
          : "";
        this.when = collection.when;
        this.when_start = collection.when_start;
        this.when_end = collection.when_end;
        this.where = collection.where;
        this.where_domains = collection.where_domains
          ? collection.where_domains
          : [];
        this.show_category = collection.show_category == true;
        this.show_item_author = collection.show_item_author == true;
        this.show_item_date = collection.show_item_date == true;
        this.show_item_view = collection.show_item_view == true;
        this.show_item_date_format = collection.show_item_date_format
          ? collection.show_item_date_format
          : "%YYYY%-%MM%-%DD%";

        const licenses = collection.channel.licenses;
        if (licenses && Array.isArray(licenses)) {
          licenses.forEach((item) => {
            if (item.mode == "api") {
              this.api_domains.push(item.domain);
            }
          });
        }

        console.log(collection.mode_collection, collection.mode_api);
      } catch (e) {
        console.log("[collection Edit] fail", e);
      }
    },
    async init() {
      this.id = this.$route.query.collection_id;
      await this.getCollection(this.id);

      this.previewUrl = process.env.VUE_APP_BASE_URL + `/collection/${this.id}`;
      console.log("프리뷰url", this.previewUrl);
      this.refreshPreview();
    },
    removeDomain(domain) {
      const index = this.where_domains.indexOf(domain);
      if (index > -1) {
        this.where_domains.splice(index, 1);
      }
    },
    async updateCollection() {
      console.log("valid", this.$refs.form.validate());

      if (
        this.$refs.form.validate() !== true ||
        this.$refs.form1.validate() !== true
      ) {
        return null;
      }

      if (this.ruleWhenStart(this.when_start) !== true) {
        this.ruleTextSchedule = this.ruleWhenStart(this.when_start);
        setTimeout(() => {
          this.ruleTextSchedule = "";
        }, 8000);
        return null;
      }

      if (this.ruleWhenEnd(this.when_end) !== true) {
        this.ruleTextSchedule = this.ruleWhenStart(this.when_end);
        setTimeout(() => {
          this.ruleTextSchedule = "";
        }, 8000);
        return null;
      }

      if (this.who == "allowed") this.mode_api = false;

      const updateInput = {
        id: this.id,
        channel_id: this.$store.state.channelId,
        title: this.title,
        date: this.date,
        info: this.info,
        header: this.header,
        back_img: this.back_img,
        back_img_login: this.back_img_login,
        selected_contents: this.selected_contents,
        selected_categories: this.selected_categories,
        selected_lives: this.selected_lives,
        who: this.who,
        who_groups: this.who_groups,
        key: this.key,
        when: this.when,
        where: this.where,
        where_domains: this.where_domains,
        mode_collection: this.mode_collection,
        mode_api: this.mode_api,
        show_category: this.show_category,
        show_item_author: this.show_item_author,
        show_item_date: this.show_item_date,
        show_item_view: this.show_item_view,
        show_item_date_format: this.show_item_date_format,
      };
      updateInput.when_start = this.when_start_local; //2021-03-24 12:00  => 2021-03-24T12:00+09:00  =>12645645645644
      updateInput.when_end = this.when_end_local;

      console.log("updateContent Exec", updateInput);

      try {
        const { data } = await this.$apollo.mutate({
          mutation: updateCollection,
          variables: {
            input: updateInput,
          },
          fetchPolicy: "no-cache",
        });

        if (data && data.updateCollection) {
          const res = data.updateCollection;

          console.log({ updateInput, res });
          // updateContent 결과 리스트에 업데이트
          this.title = res.title;
          this.info = res.info;
          this.back_img = res.back_img;
          this.who = res.who;
          this.key = res.key;
          this.when = res.when;
          this.where = res.where;
          this.where_domains = res.where_domains;

          this.$store.dispatch("logger", {
            menu: "Collections",
            level: "success",
            message: `Success for Updating ${this.id} Collection.`,
          });
        }
      } catch (e) {
        this.$store.dispatch("logger", {
          menu: "Collections",
          level: "error",
          message: `Fail for Updating  ${this.id} Collection.`,
        });
        console.log("[Collections] Update Collection", e);
      }

      this.refreshPreview();
    },
    ruleTitle(v) {
      if (!v) return "Required.";
      return true;
    },
    ruleKey(v) {
      if (this.who == "key" && !v) return "Required.";
      if (this.who == "key" && v.length > 10)
        return "Key value must be less than 10 characters";
      return true;
    },
    ruleWhenStart(v) {
      console.log(this.when);
      if (this.when == "schedule" && !v) return "Required.";
      console.log(this.when_end);

      const s = moment(this.when_start);
      const e = moment(this.when_end);
      console.log(e.diff(s));
      if (e.diff(s) < 0) return "The start date must precede the end date.";
      return true;
    },
    ruleWhenEnd(v) {
      if (this.when == "schedule" && !v) return "Required.";
      const s = moment(s);
      const e = moment(e);
      if (e.diff(s) > 0)
        return "The end date must be later than the start date.";
      return true;
    },
    updateWhoGroups(evt) {
      this.who_groups = evt;
    },
    refreshPreview() {
      const previewIfm = document.querySelector("#previewIfm");

      const url = this.previewUrl;
      console.log({ previewIfm, url });
      previewIfm.src = url;
      // previewIfm.contentWindow.location.reload();
    },
  },
};
</script>
<style scoped>
.v-input {
  font-size: 0.9em;
}

.liveLabel {
  position: absolute;
  top: 0;
  right: 0;
  background-color: red;
  padding: 0px 10px 0px 10px;
  margin: 5px;
  border-radius: 10px;
}
.content-title {
  font-size: 0.8rem;
  line-height: 1.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 3.9em;
}
.content-subtitle {
  display: inline-block;
  font-size: 0.75rem;
}
.subheading {
  font-size: 12px;
}
.domain-wrap {
  width: 100%;
  padding: 5px;
  margin-top: 2px;
  border-radius: 6px;
  border: 1px solid rgb(206, 206, 206);
}
</style>
